module.exports = __webpack_public_path__ + "media/images/athletes/4140-90d243ef0885df80619ff2d492ceaa18.png";